import { Editor } from '@tiptap/core';

export const FLOATING_MENU_SELECTOR = '.tippy-box';

type TextOption = 'bold' | 'italic' | 'strike';

export const applyTextOptionOnSelection = (editor: Editor, option: TextOption) => {
  editor.chain().focus().toggleMark(option).run();
};

export const applyLinkOnSelection = (editor: Editor, url: string) => {
  try {
    let formattedUrl = url.trim();
    if (!/^(https?:\/\/|mailto:)/i.test(formattedUrl)) {
      formattedUrl = 'https://' + formattedUrl;
    }

    const { from, to } = editor.state.selection;
    const { schema } = editor.state;
    const linkMark = schema.marks.link.create({ href: formattedUrl });
    const tr = editor.state.tr.addMark(from, to, linkMark);
    editor.view.dispatch(tr);
  } catch {
    // Silently ignore the error
  }
};

export const getSelectedLink = (editor: Editor) => {
  return editor.getAttributes('link').href;
};

export const applyEditorFloatingMenuCommand = (editor: Editor, commandFn: () => void) => {
  if (!editor) return;

  // Get current position and line info
  const { selection } = editor.state;
  const { $anchor } = selection;
  const pos = $anchor.pos;
  const currentLineStart = $anchor.start();
  const textBefore = editor.state.doc.textBetween(currentLineStart, pos, '');

  // Create a transaction to handle all our changes
  const tr = editor.state.tr;

  // Find where the slash command starts
  const slashIndex = textBefore.lastIndexOf('/');
  if (slashIndex >= 0) {
    // Delete from the slash to the current position (the entire command)
    const deleteFrom = currentLineStart + slashIndex;
    tr.delete(deleteFrom, pos);
    editor.view.dispatch(tr);
  }

  // Execute the command after the command text is removed
  commandFn();

  // Force close the floating menu by simulating an Escape key press
  const escapeEvent = new KeyboardEvent('keydown', {
    key: 'Escape',
    bubbles: true,
    cancelable: true
  });
  document.dispatchEvent(escapeEvent);

  // Set focus back to editor
  editor.view.focus();
};
